export default __webpack_public_path__ + "static/media/factory.beea9aa5.svg";